"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variantFieldsToReadable = void 0;
exports.variantFieldsToReadable = {
    variant_id: "Variant ID",
    gene: "Gene",
    chromosome: "Chromosome",
    position: "Position",
    ref: "Ref",
    alt: "Alt",
    gh37_gdna_coordinates: "GH37 gDNA Coordinates",
    hgvsg: "HGVSg",
    hgvsp: "HGVSp",
    hgvsp_brief: "HGVSp Brief",
    exonic_function: "Exonic Function",
    region: "Region",
    mutation_type: "Mutation Type",
    codon_change: "Codon Change",
    transcript: "Transcript",
    strand: "Strand",
    transvar_input: "Transvar Input",
    clinical_phenotype: "Clinical Phenotype",
    clinical_phenotype_source: "Clinical Phenotype Source",
    neuropathology_alzforum: "Neuropathology Alzforum",
    info_transvar: "Info Transvar",
    dbsnp_id_clinvar: "DbSNP ID ClinVar",
    clinvar_allele_id: "ClinVar Allele ID",
    clinvar_review_status: "ClinVar Review Status",
    clinvar_clinical_significance: "ClinVar Clinical Significance",
    intervar_classification: "InterVar Classification",
    radr_classification: "RADR Classification",
    variant_classification_source: "Variant Classification Source",
    disease_specific_pathogenicities: "Disease Specific Pathogenicities",
    odds_ratio_single_variant: "Odds Ratio (Single Variant)",
    odds_ratio_combined_variant: "Odds Ratio (Combined Variant)",
    rvas: "RVAS",
    source: "Source",
};
